import React from "react";
import "../../Home.scss";
import "../HowItWorks/HowItWorks.scss";
interface IProps { }
interface IState {
  activeTab: string;
}
export class HowItWorks extends React.Component<IProps, IState> {



  constructor(props: any) {
    super(props);
    this.state = {
      activeTab: "0",
    };
  }

  setSelectedTab(e, tabIndex) {
    e.preventDefault();
    this.setState({ activeTab: tabIndex });
    return 0;
  }

  render() {
    let defaultTabIndex = 0;
    return (
      <div className="darksection">
        <div className="w-container w-container-section">
          <div className="darksection-left">
            <h2 className="codeheader">Drive innovation, exceed expectations</h2>
            <div className="div-copy-code">
              <h4 className="codecopy">
                Our APIs empower you to build innovative solutions
                to drive a better customer experience. Check out our featured
                Payroll, Client Access, and Accounting APIs.
                </h4>
              <a id="btn-howitworks-exploremindbodyapi"
                href="PublicDocumentation/V6"
                className="btn w-button howitworks-button">Explore the Mindbody API</a>
            </div>
          </div>
          <div className="code-example light code-outer">Code Examples</div>
          <div className="darksection-right">
            <div data-duration-in="300"
              data-duration-out="100"
              className="tabs w-tabs">
              <div className="tabs-menu w-tab-menu" role="tablist">
                <div className="code-example light code-inner">Code Examples</div>
                <a
                  tabIndex={defaultTabIndex}
                  data-w-tab="Tab 1"
                  onClick={(e) => this.setSelectedTab(e, "0")}
                  className={`tabstyle w-inline-block w-tab-link link-code ${this.state.activeTab == "0" ? "w--current" : ""
                    }`}
                  id="w-tabs-0-data-w-tab-0"
                  href="#w-tabs-0-data-w-pane-0"
                  role="tab"
                  aria-controls="w-tabs-0-data-w-pane-0"
                  aria-selected={this.state.activeTab == "0"}
                >
                  <div className="div-tab-head">Payroll</div>
                </a>
                <a

                  data-w-tab="Tab 3"
                  onClick={(e) => this.setSelectedTab(e, "2")}
                  className={`tabstyle w-inline-block w-tab-link link-code ${this.state.activeTab == "2" ? "w--current" : ""
                    }`}
                  tabIndex={defaultTabIndex}
                  id="w-tabs-0-data-w-tab-2"
                  href="#w-tabs-0-data-w-pane-2"
                  role="tab"
                  aria-controls="w-tabs-0-data-w-pane-2"
                  aria-selected={this.state.activeTab == "2"}
                >
                  <div className="div-tab-head">Client Access</div>
                </a>
                <a

                  data-w-tab="Tab 2"
                  onClick={(e) => this.setSelectedTab(e, "1")}
                  className={`tabstyle w-inline-block w-tab-link link-code  ${this.state.activeTab == "1" ? "w--current" : ""
                    }`}
                  tabIndex={defaultTabIndex}
                  id="w-tabs-0-data-w-tab-1"
                  href="#w-tabs-0-data-w-pane-1"
                  role="tab"
                  aria-controls="w-tabs-0-data-w-pane-1"
                  aria-selected={this.state.activeTab == "1"}
                >
                  <div className="div-tab-head">Accounting</div>
                </a>
              </div>
            </div>
            <div className="tabs-content w-tab-content">
              <div
                data-w-tab="Tab 1"
                className={`codeexamples w-tab-pane ${this.state.activeTab == "0" ? "w--tab-active tab-animation" : ""
                  }`}
                id="w-tabs-0-data-w-pane-0"
                role="tabpanel"
                aria-labelledby="w-tabs-0-data-w-tab-0"
              >
                <div className="tabcontainer">
                  <div
                    id="w-node-fcc8982c-4ad2-5cea-a9a6-d7bb049491ca-049491b0"
                    className="sandbox"
                  >
                    <p className="paragraph">
                    <span className="color-light-blue">var</span> client = <span className="color-light-blue">new</span><br/>
                    <span className="color-green">RestClient</span>(<span className="color-orange">"https://api.mindbodyonline.com/public/v6/payroll/commissions"</span>);{" "}
                      <br />
                      <span className="color-light-blue">var</span> request = <span className="color-light-blue">new</span> <span className="color-green">RestRequest</span><span className="color-light-blue">(</span>Method<span className="color-light-blue">.GET);</span>
                      <br />
                      request<span className="color-light-blue">.AddHeader(</span><span className="color-orange">"SiteId", "{'-99"'}</span><span className="color-light-blue">);</span>
                      <br />
                      request<span className="color-light-blue">.AddHeader(</span><span className="color-orange">"Api-Key", "
                      {"b5fd5260655140668edde9209c55b87e"}"</span><span className="color-light-blue">);</span>
                      <br />
                      IRestResponse response = client<span className="color-light-blue">.Execute(</span>request<span className="color-light-blue">);</span>
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-w-tab="Tab 3"
                className={`codeexamples w-tab-pane ${this.state.activeTab == "2" ? "w--tab-active tab-animation" : ""
                  }`}
                id="w-tabs-0-data-w-pane-2"
                role="tabpanel"
                aria-labelledby="w-tabs-0-data-w-tab-2"
              >
                <div className="tabcontainer">
                  <div
                    id="w-node-cd236b0d-f103-8cfc-7015-361716529303-049491b0"
                    className="sandbox"
                  >
                    <p className="paragraph">
                    <span className="color-light-blue">var</span> client = <span className="color-light-blue">new </span>
                    <span className="color-green">RestClient</span>(<span className="color-orange">"https://api.mindbodyonline.com/public/v6/client/clientcompleteinfo?ClientId=
                      {"100013562"}"</span>); <br />
                      <span className="color-light-blue">var</span> request = <span className="color-light-blue">new</span> <span className="color-green">RestRequest</span><span className="color-light-blue">(</span>Method<span className="color-light-blue">.GET);</span> <br />
                      request<span className="color-light-blue">.AddHeader(</span><span className="color-orange">"SiteId","{'-99"'}</span><span className="color-light-blue">);</span>
                      <br />
                      request<span className="color-light-blue">.AddHeader(</span><span className="color-orange">"Api-Key", "
                      {"b5fd5260655140668edde9209c55b87e"}"</span><span className="color-light-blue">);</span>
                      <br />
                      request<span className="color-light-blue">.AddHeader(</span><span className="color-orange">"Authorization", "
                      {
                        "bae2ee52ca8341b9b478cb7a95181ff373e14dca2e794f0b9e590070e2ebbe6a"
                      }
                      "</span><span className="color-light-blue">);</span> <br />
                      IRestResponse response = client<span className="color-light-blue">.Execute(</span>request<span className="color-light-blue">);</span>
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-w-tab="Tab 2"
                className={`codeexamples w-tab-pane ${this.state.activeTab == "1" ? "w--tab-active tab-animation" : ""
                  }`}
                id="w-tabs-0-data-w-pane-1"
                role="tabpanel"
                aria-labelledby="w-tabs-0-data-w-tab-1"
              >
                <div className="tabcontainer">
                  <div
                    id="w-node-_3b54a35c-d702-e442-fdcc-9fd8bfe9a238-049491b0"
                    className="sandbox"
                  >
                    <p className="paragraph">
                      <span className="color-light-blue">var</span> client = <span className="color-light-blue">new</span><br/>
                      <span className="color-green">RestClient</span>(<span className="color-orange">"https://api.mindbodyonline.com/public/v6/site/paymenttypes"</span>);{" "}
                      <br />
                      <span className="color-light-blue">var</span> request = <span className="color-light-blue">new</span> <span className="color-green">RestRequest</span><span className="color-light-blue">(</span>Method<span className="color-light-blue">.GET);</span> <br />
                      request<span className="color-light-blue">.AddHeader(</span><span className="color-orange">"SiteId",  "{'-99"'}</span><span className="color-light-blue">);</span>
                      <br />
                      request<span className="color-light-blue">.AddHeader(</span> <span className="color-orange">"Api-Key", "
                     {"b5fd5260655140668edde9209c55b87e"}"</span><span className="color-light-blue">);</span>
                      <br />
                      request<span className="color-light-blue">.AddHeader(</span> <span className="color-orange">"Authorization", "
                      {
                        "bae2ee52ca8341b9b478cb7a95181ff373e14dca2e794f0b9e590070e2ebbe6a"
                      }
                      "</span><span className="color-light-blue">);</span> <br />
                      request<span className="color-light-blue">.AddHeader(</span><span className="color-orange" >"Content-Type", "application/json"</span><span className="color-light-blue">);</span>
                      <br />
                      IRestResponse response = client<span className="color-light-blue">.Execute(</span>request<span className="color-light-blue">);</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HowItWorks;
